export default "__VITE_ASSET__Bb_ynDJC__"